import { Box, Stack, Divider, Button, IconButton, Typography, useTheme } from "@mui/material";
import { useContext } from "react";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import SystemUserComponent from "../../components/SystemUser/SystemUserComponent";
import {Context} from "../../index";

const Profile = () => {
    const {store} = useContext(Context);
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <Box m="20px">
            {/* HEADER */}
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Header title="Profile" subtitle="Information about you" />

                {/*<Box>*/}
                {/*    <Button*/}
                {/*        sx={{*/}
                {/*            backgroundColor: colors.blueAccent[700],*/}
                {/*            color: colors.grey[100],*/}
                {/*            fontSize: "14px",*/}
                {/*            fontWeight: "bold",*/}
                {/*            padding: "10px 20px",*/}
                {/*        }}*/}
                {/*    >*/}
                {/*        <DownloadOutlinedIcon sx={{ mr: "10px" }} />*/}
                {/*        Download Reports*/}
                {/*    </Button>*/}
                {/*</Box>*/}
            </Box>
            <SystemUserComponent
                systemUser={store.user}
            />
        </Box>
    )

};

export default Profile;